import { render, staticRenderFns } from "./NewDynamicStatus.vue?vue&type=template&id=7854fa22&"
import script from "./NewDynamicStatus.vue?vue&type=script&lang=js&"
export * from "./NewDynamicStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports